<div class="flex flex-auto flex-col items-center justify-between">
    <!-- Logo -->
    <app-startup-logo></app-startup-logo>

    <div class="start-up-form-container">
        <!-- <div class="mx-auto w-full max-w-80 sm:mx-0 sm:w-80"> -->
        <div class="min-w-full">
            <!-- Title -->
            <div class="sho-start-up-title">Unlock your session</div>
            <div class="mt-0.5 font-medium">
                Your session is locked due to inactivity
            </div>

            <!-- Alert -->
            @if (showAlert) {
                <fuse-alert
                    class="mt-2"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'"
                >
                    {{ alert.message }}
                </fuse-alert>
            }

            <!-- Unlock form -->
            <form
                class="mt-3"
                [formGroup]="unlockSessionForm"
                #unlockSessionNgForm="ngForm"
            >
                <!-- Name field -->
                <mat-form-field class="w-full">
                    <mat-label>Full name</mat-label>
                    <input id="name" matInput [formControlName]="'name'" />
                </mat-form-field>

                <!-- Password field -->
                <mat-form-field class="w-full">
                    <mat-label>Password</mat-label>
                    <input
                        id="password"
                        matInput
                        type="password"
                        [formControlName]="'password'"
                        #passwordField
                    />
                    <button
                        mat-icon-button
                        type="button"
                        (click)="
                            passwordField.type === 'password'
                                ? (passwordField.type = 'text')
                                : (passwordField.type = 'password')
                        "
                        matSuffix
                    >
                        @if (passwordField.type === 'password') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye'"
                            ></mat-icon>
                        }
                        @if (passwordField.type === 'text') {
                            <mat-icon
                                class="icon-size-5"
                                [svgIcon]="'heroicons_solid:eye-slash'"
                            ></mat-icon>
                        }
                    </button>
                    <mat-error> Password is required </mat-error>
                </mat-form-field>

                <!-- Submit button -->
                <button
                    class="btn btn-primary mt-4 w-full p-3"
                    [disabled]="unlockSessionForm.disabled"
                    (click)="unlock()"
                >
                    @if (!unlockSessionForm.disabled) {
                        <span class="flex-auto text-xl">
                            Unlock your session
                        </span>
                    }
                    @if (unlockSessionForm.disabled) {
                        <mat-progress-spinner
                            class="mx-auto"
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button>

                <!-- Form footer -->
                <div class="text-secondary mt-8 text-md font-medium">
                    <span>I'm not</span>
                    <a
                        class="ml-1 text-primary-500 hover:underline"
                        [routerLink]="['/sign-out']"
                        >{{ name }}</a
                    >
                </div>
            </form>
        </div>
    </div>

    <!-- Copyright -->
    <app-copyright></app-copyright>
</div>
